<footer class="footer">
  <div class="footer-main">

    <!-- Brand -->
    <div class="brand">
      <div class="brand-logo">
        <img src="assets/images/ToT-Dark-Logo.png" alt="TutorOnTip Logo" />
        <span>TutorOnTip</span>
      </div>
      <p>
        At <strong>TutorOnTip</strong>, we bridge the gap between educators and
        learners with engaging, real-world-oriented courses. Educators can design
        impactful learning experiences and expand their influence, while learners
        explore new skills, learn from trusted mentors, and move closer to their goals.
      </p>
      <p class="mission">
        Our platform is built to support growth, knowledge, and shared success.
      </p>

      <!-- <div class="newsletter">
        <p>Subscribe to our newsletter</p>
        <div class="input-row">
          <span class="mail-icon">✉</span>
          <input type="email" placeholder="Your email" />
          <button>Subscribe</button>
        </div>
      </div> -->
    </div>

    <!-- Quick Links -->
    <div class="links">
      <a routerLink="/">Home</a>
      <a routerLink="/about">About</a>
      <a routerLink="/contact">Contact Us</a>
      <a href="https://www.cliqtros.com/">Official Website</a>
      <a href="https://www.cliqtros.com/Privacy/Terms#permission_md" target="_blank" rel="noopener">Terms &amp; Conditions</a>
      <a href="https://www.cliqtros.com/Privacy" target="_blank" rel="noopener">Privacy Policy</a>
    </div>

    <!-- Social -->
    <div class="social">
      <a href="https://www.facebook.com/cliqtrossolutions/" target="_blank">Facebook</a>
      <a href="https://www.instagram.com/cliqtrossolutions/" target="_blank">Instagram</a>
      <a href="https://www.linkedin.com/company/cliqtrossolutions/" target="_blank">LinkedIn</a>
    </div>

    <!-- Contact -->
    <div class="contact">
      <h4>Contact Us</h4>
      <a href="mailto:contact@cliqtros.com">contact&#64;cliqtros.com</a>
    </div>

  </div>

  <div>
    <div class="footer-bottom">
      <p>© 2026 <strong>Cliqtros Solutions Pvt. Ltd. </strong>All Rights Reserved.</p>
    </div>
  </div>
</footer>
